import { render, staticRenderFns } from "./KbSection.vue?vue&type=template&id=61c7d46a&scoped=true&"
import script from "./KbSection.vue?vue&type=script&lang=js&"
export * from "./KbSection.vue?vue&type=script&lang=js&"
import style0 from "./KbSection.vue?vue&type=style&index=0&id=61c7d46a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c7d46a",
  null
  
)

export default component.exports